import { elementScrollIntoView } from "seamless-scroll-polyfill";

function initInfoLabelsTextCompressor() {
    const infoLabels = document.querySelector(".js-info-labels-text-compressor-init");

    if (!infoLabels) return;

    initListeners(infoLabels);
    setInitialState(infoLabels);
}

function setInitialState(section) {
    const items = section?.querySelectorAll(".info-labels-grid__item");

    if (items && items.length > 0) {
        for (const item of items) {
            const trigger = item.querySelector(".info-labels-grid__item-trigger");

            if (!item.classList.contains("collapsed")) {
                setItemActiveClass(item);
            }

            if (trigger) {
                setTriggerContent(trigger, "Показать ещё");
            }
        }
    } else {
        console.error("Items not found in", section);
    }
}

function initListeners(section) {
    const items = section?.querySelectorAll(".info-labels-grid__item");
    const triggers = section?.querySelectorAll(".info-labels-grid__item-trigger");

    if (triggers && triggers.length > 0) {
        for (const trigger of triggers) {
            trigger.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();

                const target = e.target.closest(".info-labels-grid__item");

                if (items && items.length > 0) {
                    toggleCompressText(items, triggers, target);
                } else {
                    console.error("Items not found in", section);
                }
            });
        }
    } else {
        console.error("Triggers not found in", section);
    }
}

function toggleCompressText(items, triggers, target) {
    items?.forEach((item) => {
        if (item.classList.contains("collapsed")) {
            removeItemActiveClass(item);
            triggers?.forEach((trigger) => {
                setTriggerContent(trigger, "Скрыть");
            });
        } else {
            setItemActiveClass(item);
            triggers?.forEach((trigger) => {
                setTriggerContent(trigger, "Показать ещё");
                elementScrollIntoView(target, {
                    behavior: "smooth",
                    block: "center",
                });
            });
        }
    });
}

function removeItemActiveClass(item) {
    if (!item) {
        return;
    }
    item.classList.remove("collapsed");
}

function setItemActiveClass(item) {
    if (!item) {
        return;
    }
    item.classList.add("collapsed");
}

function setTriggerContent(trigger, text) {
    if (!trigger) {
        return;
    }
    trigger.innerHTML = text;
}

if (window.mobileMedia) {
    window.addEventListener("load", () => initInfoLabelsTextCompressor());
}
